// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mb-1rem {
  margin-bottom: 1rem;
}

.mb-0 {
  margin-bottom: 0px;
}

.sortable-item {
  z-index: 9999 !important;
}

.modifiers-arrangements {
  max-height: 65vh;
  overflow-y: scroll;
  margin-bottom: 60px;
}

.width-100 {
  width: 100%;
}

.pl-half-rem {
  padding-left: 0.5rem;
}

.cursor-pointer {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductsAndModifiers/Modifiers/Modifiers.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".mb-1rem {\n  margin-bottom: 1rem;\n}\n\n.mb-0 {\n  margin-bottom: 0px;\n}\n\n.sortable-item {\n  z-index: 9999 !important;\n}\n\n.modifiers-arrangements {\n  max-height: 65vh;\n  overflow-y: scroll;\n  margin-bottom: 60px;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.pl-half-rem {\n  padding-left: 0.5rem;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
